const filmCards = document.querySelectorAll('.film-card');
filmCards.forEach(filmCard => {
  filmCard.addEventListener('focusin', (e) => {
    e.target.lastElementChild.style.opacity = 1;
    e.target.style.filter = 'grayscale(100%)';
  });
  filmCard.addEventListener('focusout', (e) => {
    e.target.lastElementChild.style.opacity = '';
    e.target.style.filter = '';
  });
})